<template lang="pug">
  v-dialog(
    id="order"
    v-model="show"
    content-class="item-dialog"
    scrollable
    tile
    max-width="800px"
  )
    //- template
    //-   v-card
    //-     v-card-title
    //-       h3.header-title Your Orders
    //-       v-spacer
    //-       v-btn(
    //-         class="close-button"
    //-         x-small
    //-         color="red"
    //-         @click="close"
    //-       )
    //-         v-icon mdi-close-box
    //-     v-card-text
    //-       b Your do not have any orders.
    template(v-if="details")
      v-card
        v-card-title
          h3.header-title Your Order ID : {{ decrypted.order_id }}
          v-spacer
          v-btn(
            class="close-button"
            x-small
            color="red"
            @click="close"
          )
            v-icon mdi-close-box
        v-card-subtitle.mt-2
          v-icon(
            color="primary"
          ) mdi-store
          b.ml-1 {{ details.merchant_name }}
          v-icon(
            color="primary"
          ) mdi-arrow-right-bold
          span.ml-1 {{ details.store_name }}
          v-icon(
            color="primary"
          ) mdi-arrow-right-bold
          v-icon(
            color="primary"
          ) mdi-chair-school
          span.ml-1 {{ details.table_name }}
        v-card-text(v-if="!order_list")
          b Your do not have any orders.
          p
          span Make orders now for them to appear here!
        v-card-text.pt-0(v-if="order_list")
          small &nbsp;&nbsp;Staff: {{ order_list.dinein_staff }}
          v-list(
            class="p-0"
            three-line
            flat
          )
            v-list-item-group(
              v-for="(s, index) in order_list.order_list"
              :key="s.suborder_id"
            )
              v-list-item-content
                v-list-item-title
                  v-icon(
                    color="green"
                  ) mdi-receipt
                  b(
                    class="ml-2 my-auto"
                  ) {{ s.suborder_id }}
              v-list-item(
                v-for="(i, index) in s.item_list"
                :key="i.item_id"
              )
                template(v-slot:default="{ active }")
                  v-list-item-content
                    v-list-item-title
                      b {{ i.item_name }}
                    v-list-item-subtitle(
                      v-if="i.item_variant"
                    ) {{ i.item_variant.variant_name }}
                    v-list-item-subtitle(
                      v-if="i.item_addon.length"
                      v-for="(a, idx) in i.item_addon"
                      :key="a.addon_id"
                    )
                      em - {{ a.addon_name }}
                    v-list-item-subtitle(v-if="i.item_remarks") * {{ i.item_remarks }}
                    v-list-item-subtitle(
                      v-if="i.suborder_paid"
                      class="text--primary"
                    ) 
                      small Paid on {{ $helpers.formatTime(i.suborder_paidt) }}
                  v-list-item-action(
                    class="m-auto"
                  )
                    span RM {{ calculatePrice(i) }}
                  v-list-item-action(
                    class="mr-2 my-auto"
                  )
                    b X {{ i.item_quantity }}
                    v-checkbox(
                      readonly
                      v-model="i.item_served"
                      label="Served?"
                    )
              v-divider(
                class="m-0"
              )
        v-card-actions.pt-0(v-if="order_list")
          .m-auto
            b Grand total
            span &nbsp;&nbsp;RM {{ order_list.order_finalprice }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: { decrypted: Object, details: Object, dialog: Boolean },
  data() {
    return {
      order_list: null,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("close");
      }
    },
    finalPrice() {
      return this.order_list.length
        ? this.order_list[0].order_list.reduce((acc, x) => {
            return acc + parseFloat(x.item_saleprice);
          }, 0)
        : 0;
    }
  },
  mounted() {
    this.$store.commit("layout/setDisplayTitle", "Your Orders");
    this.getOrderList();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    mapList(val) {
      if (!val.length) return;

      var order, list, item;

      order = new Array();

      val.map(x => {
        this.order_list = new Object({
          order_remarks: x.order_remarks,
          order_finalprice: x.order_finalprice,
          dinein_staff: x.dinein_staff
        });

        if (order.findIndex(c => c.suborder_id == x.suborder_id) == -1)
          order.push({
            suborder_id: x.suborder_id,
            item_list: []
          });

        list = order.filter(d => d.suborder_id == x.suborder_id)[0].item_list;

        if (list.findIndex(c => c.item_id == x.item_parentid) == -1)
          list.push({
            menu_id: x.menu_id,
            item_id: x.item_parentid,
            item_name: x.item_name,
            item_price: x.item_oriprice,
            item_saleprice: x.item_saleprice,
            item_quantity: x.item_quantity,
            item_remarks: x.item_remarks,
            item_served: x.item_served,
            suborder_paid: x.suborder_paid,
            suborder_paidt: x.suborder_paidt,
            item_variant: null,
            item_addon: []
          });

        item = list.filter(a => a.item_id == x.item_parentid)[0];

        if (item.item_id == x.item_parentid && x.item_childtype == 1)
          item.item_variant = {
            variant_id: x.item_id,
            variant_name: x.variant_name,
            variant_price: x.item_oriprice,
            variant_saleprice: x.item_saleprice
          };

        if (item.item_id == x.item_parentid && x.item_childtype == 2)
          item.item_addon.push({
            addon_id: x.item_id,
            addon_name: x.addon_name,
            addon_price: x.item_oriprice,
            addon_saleprice: x.item_saleprice
          });

        this.order_list.order_list = order;
      });
    },
    getOrderList() {
      this.order_list = null;

      let url = config.dineInUrl();

      var json = {
        params: {
          order_id: this.decrypted.order_id,
          merchant_id: this.decrypted.merchant_id,
          store_id: this.decrypted.store_id,
          table_id: this.decrypted.table_id,
          table_sessiontoken: this.decrypted.table_sessiontoken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (response.body.message == 0) return;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.mapList(response.body.data);
              } else {
                this.$swal(
                  this.$t("error.customer_get_order"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.customer_get_order"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.customer_get_order"),
            response.body.message,
            "error"
          );
        });
    },
    calculateOriPrice(i) {
      var total = 0;

      //normal item price
      total += parseFloat(i.item_price);

      if (i.item_variant)
        //variant price
        total += parseFloat(i.item_variant.variant_price);

      if (i.item_addon.length)
        //addon price
        i.item_addon.forEach(a => {
          total += parseFloat(a.addon_price);
        });

      return (total * i.item_quantity).toFixed(2);
    },
    calculatePrice(i) {
      var total = 0;

      //normal item price
      total +=
        parseFloat(i.item_saleprice) != 0
          ? parseFloat(i.item_saleprice)
          : parseFloat(i.item_price);

      if (i.item_variant)
        //variant price
        total +=
          parseFloat(i.item_variant.variant_saleprice) != 0
            ? parseFloat(i.item_variant.variant_saleprice)
            : parseFloat(i.item_variant.variant_price);

      if (i.item_addon.length)
        //addon price
        i.item_addon.forEach(a => {
          total +=
            parseFloat(a.addon_saleprice) != 0
              ? parseFloat(a.addon_saleprice)
              : parseFloat(a.addon_price);
        });

      return (total * i.item_quantity).toFixed(2);
    }
  }
};
</script>
